export default __webpack_public_path__ + "static/media/crowd-fund3.a4b11ba8.jpg";